import { render, staticRenderFns } from "./CountRatio.vue?vue&type=template&id=06869684&"
import script from "./CountRatio.vue?vue&type=script&lang=js&"
export * from "./CountRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports